var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrxEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    style: {
      enableBackground: "new 0 0 283.46 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.73,283.46c-19.13,0-37.69-3.75-55.17-11.14c-16.88-7.14-32.03-17.36-45.05-30.37 c-13.01-13.01-23.23-28.17-30.37-45.05C3.75,179.42,0,160.86,0,141.73s3.75-37.69,11.14-55.17c7.14-16.88,17.36-32.03,30.37-45.05 C54.53,28.5,69.68,18.28,86.56,11.14C104.04,3.75,122.6,0,141.73,0s37.69,3.75,55.17,11.14c16.88,7.14,32.03,17.36,45.05,30.37 c13.01,13.01,23.23,28.17,30.37,45.05c7.39,17.48,11.14,36.04,11.14,55.17s-3.75,37.69-11.14,55.17 c-7.14,16.88-17.36,32.03-30.37,45.05c-13.01,13.01-28.17,23.23-45.05,30.37C179.42,279.72,160.86,283.46,141.73,283.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 141.73,
    cy: 141.73,
    r: 134.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "145.03,116.52 145.03,178.36 205.57,141.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "145.03,109.54 205.02,134.47 190.68,111.09 221.17,80.6 202.95,62.37 176.83,88.5 145.03,36.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "138.59,178.36 138.59,116.52 78.05,141.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "78.6,134.47 138.59,109.54 138.59,36.66 106.8,88.5 80.67,62.37 62.45,80.6 92.94,111.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "204.89,160.92 145.03,197.2 145.03,245.25 169.66,210.54 195.37,236.25 213.59,218.03 184.79,189.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "138.59,197.2 78.73,160.92 98.83,189.23 70.03,218.03 88.25,236.25 113.96,210.55 138.59,245.24  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrxEth);
export default __webpack_public_path__ + "static/media/frxETH.0fbbeb0f445b864e9d8b135185b43c0f.svg";
export { ForwardRef as ReactComponent };